import React from 'react'
import PropTypes from 'prop-types'
import { NavLink as RRNavLink } from 'react-router-dom'

import { NavItem, NavLink } from 'reactstrap'

function NavigationItem({ label, path }) {
    if (!label) {
        return null
    }

    return (
        <NavItem className="ao-navigation__item">
            <NavLink
                tag={ props => <RRNavLink { ...props } /> }
                to={ path }
            >
                { label }
            </NavLink>
        </NavItem>
    )
}

NavigationItem.propTypes = {
    label: PropTypes.string,
    path: PropTypes.string
}

export default NavigationItem
